import React from 'react';
import { Target, TrendingUp, Users, Shield } from 'lucide-react';
const steps = [{
  icon: Target,
  title: 'Submit',
  description: 'Startups submit their pitch and business plan through our platform'
}, {
  icon: TrendingUp,
  title: 'Evaluate',
  description: 'AI-powered analysis evaluates market fit, team, and growth potential'
}, {
  icon: Users,
  title: 'Match',
  description: 'Smart matching connects startups with relevant investors based on criteria'
}, {
  icon: Shield,
  title: 'Invest',
  description: 'Streamlined due diligence and investment process'
}];
export function HowItWorks() {
  return <section className="py-24 bg-white" data-id="element-32">
      <div className="max-w-7xl mx-auto px-6" data-id="element-33">
        <div className="text-center mb-16" data-id="element-34">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-35">
            How Qlyns Capital Works
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-36">
            Streamlined process from submission to investment decision
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-37">
          {steps.map((step, index) => <div key={index} className="group p-8 bg-slate-50 rounded-2xl hover:bg-white hover:shadow-xl transition-all duration-300 border border-slate-100 hover:border-purple-100" data-id="element-38">
              <div className="w-14 h-14 bg-purple-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-purple-600 transition-colors duration-300" data-id="element-39">
                <step.icon className="w-7 h-7 text-purple-600 group-hover:text-white transition-colors duration-300" data-id="element-40" />
              </div>

              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-41">
                {step.title}
              </h3>

              <p className="text-slate-600 leading-relaxed" data-id="element-42">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}